/**
 * Pure mutation functions for delete subjects and connection actions.
 */

import {connectNetsByDescriptor, disconnectPinsByDescriptor, doDeleteSubjects} from "@buildwithflux/core";
import type {IDocumentData, IPartVersionData, PinDescriptor, UserUid, VertexUpdate} from "@buildwithflux/models";

import {FluxLogger} from "modules/storage_engine/connectors/LogConnector";

/**
 * Pure mutation function for deleting subjects.
 * Deletes elements and updates route vertices.
 */
export function applyDeleteSubjects(
    draft: IDocumentData,
    subjectUids: string[],
    vertexUpdates: VertexUpdate[],
    deselectUids?: string[],
): void {
    doDeleteSubjects(draft, subjectUids, FluxLogger, vertexUpdates, deselectUids);
}

/**
 * Pure mutation function for disconnecting pins by descriptor.
 */
export function applyDisconnectPinsByDescriptor(draft: IDocumentData, pinDescriptors: PinDescriptor[]): void {
    disconnectPinsByDescriptor(draft, pinDescriptors);
}

/**
 * Pure mutation function for connecting nets by descriptor.
 */
export function applyConnectNetsByDescriptor(
    draft: IDocumentData,
    netConnections: {netName: string; pins: PinDescriptor[]}[],
    portalPart: IPartVersionData,
    groundPart: IPartVersionData,
    userUid: UserUid,
): void {
    connectNetsByDescriptor(draft, netConnections, {
        portalPart,
        groundPart,
        userUid,
        logger: FluxLogger,
    });
}
